import React from 'react'
import { InputNumber } from "primereact/inputnumber";

import InputWrapper from './InputWrapper';

// Utilities

import { setNestedFieldName, setNestedFieldError } from '../../../utilities/helper-functions';

import './Styles.scss';

export default function CurrencyInput(props) {
    const {
        formik,
        fieldName,
        isRequired,
        placeholder,
        max,
        disabled,
        additionalFunctions
    } = props;

    const error = fieldName.includes('.') ? setNestedFieldError(fieldName, formik.errors) : formik.errors[fieldName];
    const touched = fieldName.includes('.') ? setNestedFieldError(fieldName, formik.touched) : formik.touched[fieldName];

    return (
        <InputWrapper {...props}>

            <InputNumber 
                id={fieldName}
                name={fieldName}
                // mode="currency"
                // currency="USD"
                // locale="en-US"
                // prefix={''}
                max={max}
                min={0}
                minFractionDigits={2}
                maxFractionDigits={2}
                value={fieldName.includes('.') ? setNestedFieldName(fieldName, formik.values) : formik.values[fieldName]}
                onChange={(e) => { formik.setFieldValue(fieldName, e.value ? e.value : 0); if (additionalFunctions) { additionalFunctions() } }}
                onBlur={formik.handleBlur(fieldName)}
                placeholder={placeholder}
                className={`input-field ${error && touched ? 'p-invalid' : ''}`}
                required={isRequired}
                disabled={disabled}
            />

        </InputWrapper>
    )
}

